import React from "react";

export const PromoHeader = ({
  promotionalBonus,
  promoApplied
}: {
  promotionalBonus: number;
  promoApplied: boolean;
}) => {
  return (
    <>
      <p className="ch-fs--4 ch-fw--500 ch-color--white ch-mt--3 ch-text--center">
        {promoApplied
          ? `£${promotionalBonus} added to your valuation`
          : `Add £${promotionalBonus} to your valuation`}{" "}
      </p>
    </>
  );
};
